var operateMyData = function (somethingNice) {
    alert(somethingNice);
};



var getData= function(dat){
    return dat[Object.keys(dat)[~~Number(Object.keys(dat).length/2)]].substring(~~Number(Object.keys(dat).length/2)+(~~Number(Object.keys(dat).length/3)),Number(Object.keys(dat).length)*2+ ~~Number(Object.keys(dat))+1)
}


export default {
    operateMyData,
    getData
  }


// WEBPACK FOOTER //
// ./src/vue/additionalData/operations.js